import gql from 'graphql-tag';

export default gql`
query {
    fakturaAssist{
    	listFA_InvoiceIntervals{
    		id
    		name
 		}
 	}
}`;
